module.exports = __webpack_public_path__ + "4d0e586bd89bd1be0f7b849100eee387.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/startup.png
// module id = 385
// module chunks = 0